<template>
  <div>
    <RfBaseModal
      ref="updateEditableModal"
      :title="`${selectedExperiment?.is_live_editable ? 'Disable' : 'Enable'} live editing for this experiment`"
      width="720"
      @primary="(updateEditableModal.close(), emit('updateEditable'))"
    />

    <RfExperimentStatusModal
      ref="experimentStatusModal"
      :experimentToUpdate="selectedExperiment"
      :showPromptMessage="showPromptMessage"
      @primary="submitExperimentBtn"
    />

    <RfExperimentTrafficModal
      ref="trafficEditDialog"
      :variations="selectedExperiment?.variations"
      :isLiveEditable="selectedExperiment?.is_live_editable"
      :showPromptMessage="showPromptMessage"
      @primary="updateTraffic"
    />
  </div>

  <RfBaseModal
    ref="scheduleModal"
    title="When should it be shown"
    width="750"
    @primary="updateSchedule"
  >
    <template #body>
      <RfSchedule
        ref="scheduleForm"
        :model="selectedExperiment"
        scheduleType="schedule"
        :disableStartDate="currExperimentStatus === StatusesSimplifiedConstants.running"
        showClearIcon
        experiments
        hideTime
      />
    </template>
  </RfBaseModal>
</template>

<script>
import { StatusesSimplifiedConstants } from "@/utils/constants/PromptStatusesConstants";
</script>
<script setup>
import RfExperimentStatusModal from "@/blocks/RfExperiments/RfExperimentStatusModal.vue";
import RfExperimentTrafficModal from "@/blocks/RfExperiments/RfExperimentTrafficModal.vue";
import RfBaseModal from "@/components/modals/RfBaseModal.vue";
import RfSchedule from "@/components/RfPathCreate/RfSchedule.vue";
import { useTemplateRef } from "vue";

const emit = defineEmits([
  "onStart",
  "updateEditable",
  "updateStatus",
  "updateTraffic",
  "updateSchedule",
]);
const props = defineProps({
  selectedExperiment: { type: Object, default: () => ({}) },
  showPromptMessage: { type: Boolean, default: false },
  currExperimentStatus: { type: Object, default: StatusesSimplifiedConstants.ended },
});
const experimentStatusModal = useTemplateRef("experimentStatusModal");
const updateEditableModal = useTemplateRef("updateEditableModal");
const trafficEditDialog = useTemplateRef("trafficEditDialog");
const scheduleModal = useTemplateRef("scheduleModal");
const scheduleForm = useTemplateRef("scheduleForm");

const callExperimentDialog = isExperimentRunning => {
  if (isExperimentRunning) {
    experimentStatusModal.value?.show();
  } else if (
    props.selectedExperiment?.variations?.reduce((acc, item) => acc + item.traffic_percent, 0) !==
    100
  ) {
    trafficEditDialog.value?.show({ showRun: true });
  } else {
    experimentStatusModal.value?.show();
  }
};

const submitExperimentBtn = pausePromo => {
  emit("onStart", pausePromo);
  experimentStatusModal.value?.close();
};

const openUpdateEditableModal = () => {
  updateEditableModal.value?.show();
};

const openTrafficEditDialog = () => {
  trafficEditDialog.value?.show();
};

const openScheduleModal = () => {
  scheduleModal.value?.show();
};

const updateTraffic = ({ variations, runPrompt }) => {
  emit("updateTraffic", { variations, runPrompt });
  trafficEditDialog.value?.close();
};

const updateSchedule = () => {
  const tempModel = {};
  scheduleForm.value.fillModel(tempModel);
  scheduleModal.value?.close();
  emit("updateSchedule", tempModel);
};

defineExpose({
  callExperimentDialog,
  openUpdateEditableModal,
  openTrafficEditDialog,
  openScheduleModal,
});
</script>
